/** Splits a search query into lowercase whitespace-separated tokens. */
export const searchTokens = (query: string): string[] => query.toLowerCase().split(/\s+/).filter(Boolean)

/** True when every token appears somewhere in the haystack (case-insensitive). */
export const matchesTokens = (haystack: string, tokens: string[]): boolean => {
  const target = haystack.toLowerCase()
  return tokens.every((token) => target.includes(token))
}
